/**
 * Created by badok on 27.01.17.
 */

//--------------- SORTABLE -------------------------------
    // configuration for html.sortable.js
    // based on http://josephndungu.com/tutorials/ajax-sortable-lists-rails-4
export function sorter_ready(controller) {
	controller = controller || "categories";

	$(".sortable").sortable({
		placeholder: "sortable-placeholder",
		cursor: "hand",
		opacity: 0.5,
		scroll: true,
	});

	$(".sortable")
		.sortable()
		.bind("sortupdate", function (e, ui) {
			var updated_order = [];

			$(".sortable tr").each(function (i) {
				updated_order.push({ id: $(this).data("id"), position: i + 1 });
			});

			$.ajax({
				type: "post",
				url: "/" + controller + "/resort",
				data: { order: updated_order },
			});
		});
}